import type { ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Mapped, Silent } from "@/__main__/data-model.mjs";

const Trait = Silent({
  id: String,
  name: String,
  tierTotal: Number,
}) satisfies ModelDefinition;

const Unit = Silent({
  id: String,
  characterId: String,
  name: String,
  rarity: Number,
  cost: Number,
}) satisfies ModelDefinition;

const TraitStats = Silent({
  averageNumUnits: Number,
  averagePlacement: Number,
  frequency: Number,
  tier: Number,
  trait: Trait,
}) satisfies ModelDefinition;

const UnitStats = Silent({
  averageNumUnits: Number,
  averagePlacement: Number,
  frequency: Number,
  tier: Number,
  unit: Unit,
}) satisfies ModelDefinition;

export const PlayerMatchStats = Silent({
  averagePlacement: Number,
  gameCount: Number,
  placementFrequency: Mapped({ key: String, value: Number }),
  topFour: Number,
  traitStats: Silent([TraitStats]),
  unitStats: Silent([UnitStats]),
}) satisfies ModelDefinition;

const fullModel = createModel({
  data: { playerMatchStats: PlayerMatchStats },
}).transform(PlayerMatchStats, (data) => data.data.playerMatchStats);

export default fullModel;
